import { useMutation, useQueryClient } from "@tanstack/react-query";
import { LootBoxApi, Token } from "@devour/client";
import getConfig from "@/utils/getConfig";

export function useOpenLootBox(fullToken: Token) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (instanceId: string) =>
            new LootBoxApi(getConfig(fullToken)).createLootboxInstancesIdOpen({ id: instanceId }),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ["my-lootbox-instances"] });
        },
    });
}
